import { PlayerLogicTrackType } from '../player/common/Types'
import { ILicense } from './license'
import { IMood } from './mood'
import { IStyle } from './style'

export type ImagesType = {
  original: string
  middle: string
  thumbnail: string
}

export interface ITrack {
  addedAt: string
  addedToFavorite: boolean
  beatmakerId: number
  beatmakerName: string
  demoDownloading: boolean
  isPromo?: boolean
  ordinalNumber: number
  id: number
  images: ImagesType
  minPrice: number
  mood: IMood
  name: string
  style: IStyle
  format: 'mp3' | 'm3u8'
  url: string
  mp3: string | null
  bpm: number
  type: TracksTypes
  beatmakerVerified: boolean
  engMode: boolean
  likesCount: number
  userLike: boolean
}

export interface ISong {
  id: string
  beatmakerId: number
  beatmakerName: string
  addedAt: string
  title: string
  artistId: number
  artistName: string
  format: 'mp3' | 'm3u8'
  images: ImagesType
  url: string
  type: TracksTypes
}

export type TracksTypes = 'beat' | 'free-beat' | 'song'

export const convertISongToPlayerTrack = (track: ISong) => {
  const playerTrack: PlayerLogicTrackType<ISong> = {
    format: track.format,
    url: track.url,
    images: track.images,
    type: track.type,
    title: track.title,
    artist: track.beatmakerName,
    id: track.id,
    originalData: track
  }
  return playerTrack
}
export const convertITrackToPlayerTrack = (track: ITrack) => {
  const playerTrack: PlayerLogicTrackType<ITrack> = {
    format: track.format,
    url: track.url,
    images: track.images,
    type: track.type,
    title: track.name,
    artist: track.beatmakerName,
    id: track.id,
    originalData: track
  }
  return playerTrack
}

export interface ICartTrack extends ITrack {
  // 1 stage: getFullBeats in cartService
  notReady: boolean
  licenses: ILicense[]
  license: ILicense

  // 2 stage: _processCheckResult in cartService
  fullPrice: number
  hasDiscount: boolean
  isOK: boolean
  priceWithDiscount: number
  hasRequiredPassportLicense: boolean
  cashbackAmount: number
  message: string | null

  licenseId: string
  discount: number
}
